import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, Form, Badge, Alert, InputGroup } from 'react-bootstrap';
import {
  FaPlus, FaEdit, FaTrash, FaSearch, FaFilter, FaTimes,
  FaTools, FaBuilding, FaIdCard, FaCalendarAlt,
  FaUsers, FaUserTie,
  FaShoppingCart, FaCheckCircle, FaArrowRight, FaUser, FaBox, FaHardHat, FaExclamationTriangle
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabaseClient';
import { useAuth } from '../../hooks/useAuth';

// Função para formatar CPF com máscara
const formatCpf = (cpf) => {
  // Remove tudo que não for número
  const numericCpf = cpf.replace(/\D/g, '');
  
  // Aplica a máscara XXX.XXX.XXX-XX
  if (numericCpf.length <= 3) {
    return numericCpf;
  } else if (numericCpf.length <= 6) {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3)}`;
  } else if (numericCpf.length <= 9) {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3, 6)}.${numericCpf.slice(6)}`;
  } else {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3, 6)}.${numericCpf.slice(6, 9)}-${numericCpf.slice(9, 11)}`;
  }
};

// Função para remover máscara do CPF
const removeCpfMask = (cpf) => {
  return cpf.replace(/\D/g, '');
};

// Função para validar CPF
const validarCpf = (cpf) => {
  // Remove caracteres não numéricos
  const cpfLimpo = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (cpfLimpo.length !== 11) {
    return false;
  }
  
  // Verifica se todos os dígitos são iguais (CPF inválido, mas com formato correto)
  if (/^(\d)\1{10}$/.test(cpfLimpo)) {
    return false;
  }
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (10 - i);
  }
  
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  
  if (resto !== parseInt(cpfLimpo.charAt(9))) {
    return false;
  }
  
  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (11 - i);
  }
  
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  
  if (resto !== parseInt(cpfLimpo.charAt(10))) {
    return false;
  }
  
  return true;
};

const Montadores = () => {
  const navigate = useNavigate();
  const { user, hasPermission } = useAuth();
  
  // Estados
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editingMontador, setEditingMontador] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const [activeModalTab, setActiveModalTab] = useState('dados');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [montadorasVinculadas, setMontadorasVinculadas] = useState([]);
  // Estados para validação de CPF
  const [cpfValido, setCpfValido] = useState(true);
  const [cpfMensagemErro, setCpfMensagemErro] = useState('');
  // Estados para dados do banco
  const [montadores, setMontadores] = useState([]);
  const [empresasMontadoras, setEmpresasMontadoras] = useState([]);
  const [expositores, setExpositores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [eventos, setEventos] = useState([]);
  
  // NOVO: Estado para o expositor logado
  const [expositorLogado, setExpositorLogado] = useState(null);
  const [eventosVinculados, setEventosVinculados] = useState([]);
  
  // Estado para formulário
  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    empresa_montadora_id: '',
    evento_id: ''
  });
  
  // Filtros
  const [filters, setFilters] = useState({
    search: '',
    empresa: ''
  });

  // Estados para controle do carrinho
  const [cartItemsCount, setCartItemsCount] = useState(0);
  const [showCartNotification, setShowCartNotification] = useState(false);
  const [lastAddedItem, setLastAddedItem] = useState(null);

  // Estados para expositor selecionado
  const [expositorSelecionado, setExpositorSelecionado] = useState(null);
  const [empresaMontadoraSelecionada, setEmpresaMontadoraSelecionada] = useState(null);

  // Chave para armazenar o estado do formulário no localStorage
  const FORM_STATE_KEY = 'montador_form_state';

  // Salvar e restaurar estado do formulário quando a visibilidade da página muda
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && showForm) {
        // Salvar estado atual do formulário no localStorage
        try {
          const stateToSave = {
            formData,
            editingMontador,
            activeModalTab,
            showForm
          };
          
          // Salvar apenas o ID da empresa montadora selecionada para evitar objetos circulares
          if (empresaMontadoraSelecionada) {
            stateToSave.empresaMontadoraId = empresaMontadoraSelecionada.id;
          }
          
          // Salvar apenas o ID do expositor selecionado
          if (expositorSelecionado) {
            stateToSave.expositorId = expositorSelecionado.id;
          }
          
          localStorage.setItem(FORM_STATE_KEY, JSON.stringify(stateToSave));
          console.log('💾 Estado do formulário salvo no localStorage');
        } catch (error) {
          console.error('Erro ao salvar estado do formulário:', error);
        }
      } else if (document.visibilityState === 'visible') {
        // Verificar se há estado salvo e restaurar
        try {
          const savedState = localStorage.getItem(FORM_STATE_KEY);
          if (savedState) {
            const parsedState = JSON.parse(savedState);
            
            // Restaurar o estado do formulário
            setFormData(parsedState.formData || {});
            setEditingMontador(parsedState.editingMontador);
            setActiveModalTab(parsedState.activeModalTab || 'dados');
            setShowForm(parsedState.showForm);
            
            // Restaurar empresa montadora a partir do ID
            if (parsedState.empresaMontadoraId && empresasMontadoras.length > 0) {
              const empresa = empresasMontadoras.find(emp => emp.id === parsedState.empresaMontadoraId);
              if (empresa) {
                setEmpresaMontadoraSelecionada(empresa);
              }
            }
            
            // Restaurar expositor a partir do ID
            if (parsedState.expositorId && expositores.length > 0) {
              const expositor = expositores.find(exp => exp.id === parsedState.expositorId);
              if (expositor) {
                setExpositorSelecionado(expositor);
              }
            }
            
            console.log('🔄 Estado do formulário restaurado do localStorage');
          }
        } catch (error) {
          console.error('Erro ao restaurar estado do formulário:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [formData, showForm, editingMontador, activeModalTab, empresaMontadoraSelecionada, expositorSelecionado, empresasMontadoras, expositores]);

  // Limpar estado salvo quando o formulário é fechado
  useEffect(() => {
    if (!showForm) {
      localStorage.removeItem(FORM_STATE_KEY);
    }
  }, [showForm]);

  // Manipular mudança no campo CPF
  const handleCpfChange = (e) => {
    const { value } = e.target;
    
    // Remove tudo que não for número
    const cpfLimpo = value.replace(/\D/g, '');
    
    // Limita a 11 dígitos
    if (cpfLimpo.length <= 11) {
      // Formata o CPF com máscara
      const cpfFormatado = formatCpf(cpfLimpo);
      
      setFormData({
        ...formData,
        cpf: cpfFormatado
      });
      
      // Se o CPF estiver completo (11 dígitos), valida
      if (cpfLimpo.length === 11) {
        const ehValido = validarCpf(cpfLimpo);
        setCpfValido(ehValido);
        setCpfMensagemErro(ehValido ? '' : 'CPF inválido. Verifique os números digitados.');
      } else {
        // Se não estiver completo, não mostra erro ainda
        setCpfValido(true);
        setCpfMensagemErro('');
      }
    }
  };

  // NOVA FUNÇÃO: Verificar se usuário é administrador
  const isAdmin = () => {
    return hasPermission && (hasPermission('admin') || hasPermission('administrador') || user?.role === 'admin');
  };

  // NOVA FUNÇÃO: Buscar expositor logado baseado no email do usuário
  const fetchExpositorLogado = async () => {
    try {
      if (!user?.email) {
        console.log('Usuário não logado ou sem email');
        return;
      }

      if (isAdmin()) {
        console.log('Usuário é administrador - não vinculado a expositor específico');
        setExpositorLogado(null);
        await fetchTodosEventos();
        return;
      }

      console.log('Buscando expositor para o email:', user.email);
      
      const { data, error } = await supabase
        .from('caex_expositores')
        .select('*')
        .eq('email', user.email)
        .eq('ativo', true)
        .single();
      
      if (error) {
        if (error.code === 'PGRST116') {
          console.log('Nenhum expositor encontrado para este email');
          setError('Nenhum expositor encontrado para este usuário. Entre em contato com o administrador.');
          return;
        }
        throw error;
      }
      
      console.log('Expositor encontrado:', data);
      setExpositorLogado(data);
      
      await fetchEventosVinculados(data.id);
      
    } catch (error) {
      console.error('Erro ao buscar expositor logado:', error);
      setError('Erro ao carregar dados do expositor. Tente novamente.');
    }
  };

  // NOVA FUNÇÃO: Buscar todos os eventos (para administradores)
  const fetchTodosEventos = async () => {
    try {
      console.log('Buscando todos os eventos (admin)...');
      
      const { data, error } = await supabase
        .from('caex_eventos')
        .select('*')
        .eq('ativo', true)
        .order('data_inicio', { ascending: false });
      
      if (error) throw error;
      
      console.log('Todos os eventos carregados:', data);
      setEventosVinculados(data || []);
      
    } catch (error) {
      console.error('Erro ao buscar todos os eventos:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Buscar eventos vinculados ao expositor
  const fetchEventosVinculados = async (expositorId) => {
    try {
      console.log('Buscando eventos vinculados ao expositor:', expositorId);
      
      const { data, error } = await supabase
        .from('caex_expositor_evento')
        .select(`
          evento_id,
          caex_eventos (
            id,
            nome,
            descricao,
            data_inicio,
            data_fim,
            local,
            status
          )
        `)
        .eq('expositor_id', expositorId);
      
      if (error) throw error;
      
      const eventosData = data?.map(item => item.caex_eventos).filter(evento => evento) || [];
      
      console.log('Eventos vinculados encontrados:', eventosData);
      setEventosVinculados(eventosData);
      
    } catch (error) {
      console.error('Erro ao buscar eventos vinculados:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Buscar eventos vinculados ao expositor da empresa montadora selecionada
  const fetchEventosVinculadosAoExpositor = async (expositorId) => {
    try {
      console.log('Buscando eventos vinculados ao expositor da empresa montadora:', expositorId);
      
      const { data, error } = await supabase
        .from('caex_expositor_evento')
        .select(`
          evento_id,
          caex_eventos (
            id,
            nome,
            descricao,
            data_inicio,
            data_fim,
            local,
            status
          )
        `)
        .eq('expositor_id', expositorId);
      
      if (error) throw error;
      
      const eventosData = data?.map(item => item.caex_eventos).filter(evento => evento) || [];
      
      console.log('Eventos vinculados ao expositor da empresa montadora encontrados:', eventosData);
      setEventosVinculados(eventosData);
      
    } catch (error) {
      console.error('Erro ao buscar eventos vinculados ao expositor da empresa montadora:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Carregar carrinho do banco de dados
  const loadCartFromDatabase = async () => {
    if (!user?.id) {
      setCartItemsCount(0);
      return;
    }

    try {
      const { data, error } = await supabase
        .from('caex_carrinho_pedido')
        .select('quantidade')
        .eq('usuario_id', user.id);

      if (error) throw error;

      const totalItems = data.reduce((total, item) => total + item.quantidade, 0);
      setCartItemsCount(totalItems);
    } catch (error) {
      console.error('Erro ao carregar carrinho:', error);
      setCartItemsCount(0);
    }
  };

  // NOVA FUNÇÃO: Adicionar montador ao carrinho no banco de dados
  const addMontadorToCartDatabase = async (montadorData) => {
    try {
      if (!user?.id) {
        throw new Error('Usuário não autenticado');
      }

      if (!montadorData.nome || !montadorData.cpf || !montadorData.empresa_montadora_id) {
        throw new Error('Dados do montador incompletos');
      }

      // Buscar produto vinculado a montadores
      const produtoReferencia = produtos.length > 0 ? produtos[0] : null;
      
      if (!produtoReferencia) {
        throw new Error('Nenhum produto disponível para montadores');
      }

      // Buscar dados da empresa montadora
      const empresaMontadora = empresasMontadoras.find(emp => emp.id === montadorData.empresa_montadora_id);
      
      if (!empresaMontadora) {
        throw new Error('Empresa montadora não encontrada');
      }

      // Buscar dados do expositor vinculado à empresa montadora
      let expositorVinculado = null;
      if (empresaMontadora.expositor_id) {
        const { data: expositorData, error: expositorError } = await supabase
          .from('caex_expositores')
          .select('*')
          .eq('id', empresaMontadora.expositor_id)
          .eq('ativo', true)
          .single();
        
        if (!expositorError && expositorData) {
          expositorVinculado = expositorData;
        }
      }

      // Dados do novo montador
      const novoMontadorData = {
        id: montadorData.id,
        cpf: montadorData.cpf,
        empresa_montadora_id: montadorData.empresa_montadora_id,
        empresa_montadora_nome: empresaMontadora.nome,
        produto_id: produtoReferencia.id,
        produto_nome: produtoReferencia.nome,
        expositor_id: expositorVinculado?.id || null,
        expositor_nome: expositorVinculado?.nome_empresa || null,
        evento_id: montadorData.evento_id
      };

      // Verificar se já existe item similar no carrinho
      const { data: existingItem } = await supabase
        .from('caex_carrinho_pedido')
        .select('*')
        .eq('usuario_id', user.id)
        .eq('produto_id', produtoReferencia.id)
        .contains('dados_extras', { category: 'Montador' })
        .single();

      if (existingItem) {
        // Atualizar item existente adicionando o novo montador
        let dadosExtrasAtualizados = { ...existingItem.dados_extras };
        
        // Verificar se montadorData já é um array ou objeto único
        if (Array.isArray(dadosExtrasAtualizados.montadorData)) {
          // Já é array, adicionar novo montador
          dadosExtrasAtualizados.montadorData.push(novoMontadorData);
        } else {
          // É objeto único, converter para array e adicionar novo montador
          dadosExtrasAtualizados.montadorData = [
            dadosExtrasAtualizados.montadorData,
            novoMontadorData
          ];
        }

        const { error } = await supabase
          .from('caex_carrinho_pedido')
          .update({
            quantidade: existingItem.quantidade + 1,
            dados_extras: dadosExtrasAtualizados,
            updated_at: new Date().toISOString()
          })
          .eq('id', existingItem.id);

        if (error) throw error;
        console.log('Montador adicionado ao item existente no carrinho');
      } else {
        // Inserir novo item
        const cartData = {
          usuario_id: user.id,
          produto_id: produtoReferencia.id,
          quantidade: 1,
          preco_original: parseFloat(produtoReferencia.preco),
          preco_customizado: null,
          desconto: 0,
          tipo_desconto: 'value',
          dados_extras: {
            category: 'Montador',
            montadorData: novoMontadorData
          }
        };

        const { error } = await supabase
          .from('caex_carrinho_pedido')
          .insert([cartData]);

        if (error) throw error;
        console.log('Novo montador adicionado ao carrinho no banco');
      }

      // Atualizar contador do carrinho
      await loadCartFromDatabase();

      // Preparar dados para notificação
      const addedItem = {
        id: `montador-${montadorData.id}`,
        name: montadorData.nome,
        description: `Montador - ${empresaMontadora.nome}`,
        price: produtoReferencia.preco,
        quantity: 1,
        category: 'Montador'
      };

      setLastAddedItem(addedItem);
      setShowCartNotification(true);

      // Esconder notificação após 5 segundos
      setTimeout(() => {
        setShowCartNotification(false);
      }, 5000);

      return addedItem;
    } catch (error) {
      console.error('Erro ao adicionar montador ao carrinho:', error);
      alert('Erro ao adicionar montador ao carrinho: ' + error.message);
      return null;
    }
  };

  // Buscar montadores do banco de dados
  const fetchMontadores = async () => {
    try {
      setLoading(true);
      console.log('Iniciando carregamento de montadores...');
      
      let query = supabase
        .from('caex_montadores')
        .select(`
          *,
          caex_empresas_montadoras (
            id,
            nome,
            expositor_id,
            caex_expositores (
              id,
              nome_empresa
            )
          )
        `)
        .order('id', { ascending: false });
      
      // Se não for admin e há expositor logado, filtrar por expositor
      if (!isAdmin() && expositorLogado) {
        // Buscar empresas montadoras vinculadas ao expositor
        const { data: empresasVinculadas } = await supabase
          .from('caex_empresas_montadoras')
          .select('id')
          .eq('expositor_id', expositorLogado.id);
        
        if (empresasVinculadas && empresasVinculadas.length > 0) {
          const empresasIds = empresasVinculadas.map(emp => emp.id);
          query = query.in('empresa_montadora_id', empresasIds);
        } else {
          // Se não há empresas vinculadas, não mostrar nenhum montador
          setMontadores([]);
          setLoading(false);
          return;
        }
      }
      
      const { data, error } = await query;
      
      if (error) {
        console.error('Erro ao buscar montadores:', error);
        throw error;
      }
      
      console.log('Montadores carregados:', data);
      
      // Aplicar máscara de CPF ao carregar dados
      const dataWithFormattedCpf = data ? data.map(montador => ({
        ...montador,
        cpf: montador.cpf ? formatCpf(montador.cpf) : ''
      })) : [];
      
      setMontadores(dataWithFormattedCpf);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar montadores:', error);
      setError('Não foi possível carregar a lista de montadores.');
      setLoading(false);
    }
  };

  // Buscar empresas montadoras do banco de dados
  const fetchEmpresasMontadoras = async () => {
    try {
      console.log('Carregando empresas montadoras...');
      
      // Para administradores, carrega todas as empresas montadoras
      if (isAdmin()) {
        const { data, error } = await supabase
          .from('caex_empresas_montadoras')
          .select(`
            *,
            caex_expositores (
              id,
              nome_empresa,
              cnpj
            )
          `)
          .eq('ativo', true)
          .order('nome');
        
        if (error) throw error;
        console.log('Empresas montadoras carregadas (admin):', data);
        setEmpresasMontadoras(data || []);
        return;
      }
      
      // Para expositores, usa a tabela de junção
      if (expositorLogado) {
        // Primeiro, busca IDs das montadoras vinculadas ao expositor na tabela de junção
        const { data: vinculosData, error: vinculosError } = await supabase
          .from('caex_montadora_expositor_evento')
          .select('montadora_id')
          .eq('expositor_id', expositorLogado.id)
          .eq('ativo', true);
        
        if (vinculosError) throw vinculosError;
        
        // Se não há vínculos, retorna lista vazia
        if (!vinculosData || vinculosData.length === 0) {
          console.log('Nenhuma empresa montadora vinculada ao expositor.');
          setEmpresasMontadoras([]);
          return;
        }
        
        // Extrai os IDs das montadoras
        const montadoraIds = vinculosData.map(vinculo => vinculo.montadora_id);
        
        // Busca detalhes das montadoras pelos IDs obtidos
        const { data: montadorasData, error: montadorasError } = await supabase
          .from('caex_empresas_montadoras')
          .select(`
            *,
            caex_expositores (
              id,
              nome_empresa,
              cnpj
            )
          `)
          .in('id', montadoraIds)
          .eq('ativo', true)
          .order('nome');
        
        if (montadorasError) throw montadorasError;
        
        console.log('Empresas montadoras vinculadas carregadas:', montadorasData);
        setEmpresasMontadoras(montadorasData || []);
      } else {
        setEmpresasMontadoras([]);
      }
    } catch (error) {
      console.error('Erro ao carregar empresas montadoras:', error);
      setEmpresasMontadoras([]);
    }
  };

  // Buscar expositores do banco de dados
  const fetchExpositores = async () => {
    try {
      console.log('Carregando expositores...');
      
      const { data, error } = await supabase
        .from('caex_expositores')
        .select('id, nome_empresa, cnpj')
        .eq('ativo', true)
        .order('nome_empresa');
      
      if (error) {
        console.error('Erro ao buscar expositores:', error);
        throw error;
      }
      
      console.log('Expositores carregados:', data);
      setExpositores(data || []);
    } catch (error) {
      console.error('Erro ao carregar expositores:', error);
    }
  };

  // Buscar produtos vinculados a montadores
  const fetchProdutos = async () => {
    try {
      console.log('Carregando produtos vinculados a montadores...');
      
      const { data, error } = await supabase
        .from('caex_produtos')
        .select('id, nome, descricao, preco, imagem_url')
        .eq('ativo', true)
        .eq('vinculado_montador', true)
        .order('nome');
      
      if (error) {
        console.error('Erro ao buscar produtos:', error);
        throw error;
      }
      
      console.log('Produtos carregados:', data);
      setProdutos(data || []);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
    }
  };


const fetchMontadorasVinculadas = async () => {
  try {
    if (!expositorLogado?.id) {
      setMontadorasVinculadas([]);
      return;
    }

    console.log('Buscando montadoras vinculadas ao expositor:', expositorLogado.id);
    
    const { data, error } = await supabase
      .from('caex_montadora_expositor_evento')
      .select(`
        id,
        montadora_id,
        expositor_id,
        evento_id,
        caex_empresas_montadoras (
          id,
          nome,
          cnpj
        )
      `)
      .eq('expositor_id', expositorLogado.id)
      .eq('ativo', true);
    
    if (error) throw error;
    
    console.log('Montadoras vinculadas encontradas:', data);
    setMontadorasVinculadas(data || []);
    
  } catch (error) {
    console.error('Erro ao buscar montadoras vinculadas:', error);
    setMontadorasVinculadas([]);
  }
};

  // Carregar dados ao montar o componente
  useEffect(() => {
    const initializeData = async () => {
      if (user?.email) {
        await fetchExpositorLogado();
        await fetchExpositores();
        await fetchProdutos();
        await loadCartFromDatabase();
      }
    };
    
    initializeData();
  }, [user]);

  // Carregar empresas montadoras e montadores quando expositor logado for definido ou se for admin
useEffect(() => {
  if (expositorLogado || isAdmin()) {
    fetchEmpresasMontadoras();
    fetchMontadores();
    
    // Adicione esta linha
    if (expositorLogado && !isAdmin()) {
      fetchMontadorasVinculadas();
    }
  }
}, [expositorLogado, user]);

  // Componente para exibir eventos vinculados em dropdown
  const renderEventosDropdown = () => {
    if (eventosVinculados.length === 0) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#6c757d',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <FaCalendarAlt style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }} />
          <div>Nenhum evento vinculado a este expositor</div>
          <small>Entre em contato com o administrador para vincular eventos</small>
        </div>
      );
    }

    return (
      <select
        id="evento_id"
        name="evento_id"
        value={formData.evento_id}
        onChange={handleChange}
        className="form-input"
        required
      >
        <option value="">Selecione o evento</option>
        {eventosVinculados.map(evento => {
          const dataInicio = new Date(evento.data_inicio).toLocaleDateString('pt-BR');
          const dataFim = new Date(evento.data_fim).toLocaleDateString('pt-BR');
          const eventoLabel = `${evento.nome} (${dataInicio} - ${dataFim})`;
          
          return (
            <option key={evento.id} value={evento.id}>
              {eventoLabel}
            </option>
          );
        })}
      </select>
    );
  };

  // NOVA FUNÇÃO: Manipular seleção de empresa montadora
  const handleEmpresaMontadoraChange = async (e) => {
    const empresaId = e.target.value;
    
    if (empresaId) {
      const empresa = empresasMontadoras.find(emp => emp.id === parseInt(empresaId));
      setEmpresaMontadoraSelecionada(empresa);
      
      // Atualizar formulário
      setFormData({
        ...formData,
        empresa_montadora_id: empresaId
      });
      
      // Se a empresa tem expositor vinculado, buscar eventos desse expositor
      if (empresa && empresa.expositor_id) {
        await fetchEventosVinculadosAoExpositor(empresa.expositor_id);
        
        // Buscar dados do expositor
        const expositor = expositores.find(exp => exp.id === empresa.expositor_id);
        setExpositorSelecionado(expositor || null);
      } else {
        // Se não tem expositor vinculado, limpar eventos
        setEventosVinculados([]);
        setExpositorSelecionado(null);
      }
    } else {
      setEmpresaMontadoraSelecionada(null);
      setExpositorSelecionado(null);
      setFormData({
        ...formData,
        empresa_montadora_id: ''
      });
      
      // Se for admin, mostrar todos os eventos
      if (isAdmin()) {
        await fetchTodosEventos();
      } else if (expositorLogado) {
        await fetchEventosVinculados(expositorLogado.id);
      }
    }
  };

  // Renderizar campo de empresa montadora
  const renderEmpresaMontadoraField = () => {
    if (empresasMontadoras.length === 0) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#6c757d',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <FaBuilding style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }} />
          <div>Nenhuma empresa montadora disponível</div>
          <small>
            {isAdmin() 
              ? 'Cadastre empresas montadoras primeiro' 
              : 'Nenhuma empresa montadora vinculada ao seu expositor'
            }
          </small>
        </div>
      );
    }

    return (
      <div>
        <select
          id="empresa_montadora_id"
          name="empresa_montadora_id"
          value={formData.empresa_montadora_id}
          onChange={handleEmpresaMontadoraChange}
          className="form-input"
          required
        >
          <option value="">Selecione a empresa montadora</option>
          {empresasMontadoras.map(empresa => (
            <option key={empresa.id} value={empresa.id}>
              {empresa.nome} - {empresa.cnpj}
              {empresa.caex_expositores && ` (${empresa.caex_expositores.nome_empresa})`}
            </option>
          ))}
        </select>
        
        {empresaMontadoraSelecionada && (
          <div className="empresa-info mt-2">
            <div className="empresa-card">
              <FaBuilding className="empresa-icon" />
              <div>
                <div style={{ fontWeight: '600' }}>{empresaMontadoraSelecionada.nome}</div>
                <small>CNPJ: {empresaMontadoraSelecionada.cnpj}</small>
                {empresaMontadoraSelecionada.caex_expositores && (
                  <div style={{ fontSize: '0.8rem', color: '#28a745', marginTop: '0.25rem' }}>
                    <FaUser className="me-1" />
                    Expositor: {empresaMontadoraSelecionada.caex_expositores.nome_empresa}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderProdutosDropdown = () => {
    if (produtos.length === 0) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#6c757d',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <FaBox style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }} />
          <div>Nenhum produto disponível para montadores</div>
        </div>
      );
    }

    return (
      <div>
        <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#6c757d' }}>
          Produtos vinculados ao montador:
        </div>
        
        {produtos.map(produto => (
          <div
            key={produto.id}
            className="produto-card selected"
          >
            <div style={{ marginRight: '0.75rem', display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={true}
                disabled={true}
                style={{
                  width: '18px',
                  height: '18px',
                  accentColor: '#28a745',
                  cursor: 'not-allowed'
                }}
                readOnly
              />
            </div>
            
            <div className="produto-image">
              {produto.imagem_url ? (
                <img 
                  src={produto.imagem_url} 
                  alt={produto.nome}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }}
                />
              ) : (
                <FaBox style={{ color: '#6c757d', fontSize: '1.2rem' }} />
              )}
            </div>
            
            <div className="produto-info">
              <div className="produto-nome">{produto.nome}</div>
            </div>
          </div>
        ))}
        
        <div style={{
          marginTop: '1rem',
          padding: '0.75rem',
          backgroundColor: '#d1ecf1',
          color: '#0c5460',
          border: '1px solid #bee5eb',
          borderRadius: '8px',
          fontSize: '0.85rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <FaCheckCircle />
          Todos os produtos estão automaticamente vinculados aos montadores
        </div>
      </div>
    );
  };

  // Handlers
  const handleAddMontador = () => {
    setEditingMontador(null);
    setEmpresaMontadoraSelecionada(null);
    setExpositorSelecionado(null);
    
    setFormData({
      nome: '',
      cpf: '',
      empresa_montadora_id: '',
      evento_id: ''
    });
    setShowForm(true);
    setActiveModalTab('dados');
    
    // Se for admin, carregar todos os eventos
    if (isAdmin()) {
      fetchTodosEventos();
    } else if (expositorLogado) {
      fetchEventosVinculados(expositorLogado.id);
    }
  };

  const handleEditMontador = (montador) => {
    setEditingMontador(montador);

    // Selecionar empresa montadora
    const empresa = empresasMontadoras.find(emp => emp.id === montador.empresa_montadora_id);
    setEmpresaMontadoraSelecionada(empresa || null);
    
    // Se a empresa tem expositor vinculado, carregar eventos
    if (empresa && empresa.expositor_id) {
      fetchEventosVinculadosAoExpositor(empresa.expositor_id);
      const expositor = expositores.find(exp => exp.id === empresa.expositor_id);
      setExpositorSelecionado(expositor || null);
    }

    setFormData({
      nome: montador.nome,
      cpf: montador.cpf ? formatCpf(montador.cpf) : '', // Aplicar máscara ao CPF ao carregar para edição
      empresa_montadora_id: montador.empresa_montadora_id?.toString() || '',
      evento_id: montador.evento_id?.toString() || ''
    });
    setShowForm(true);
    setActiveModalTab('dados');
  };

  const handleDeleteMontador = (montador) => {
    setEditingMontador(montador);
    setShowDelete(true);
  };

  // Excluir montador do banco de dados
  const deleteMontador = async (id) => {
    try {
      const { error } = await supabase
        .from('caex_montadores')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      
      setMontadores(montadores.filter(montador => montador.id !== id));
      setShowDelete(false);
    } catch (error) {
      console.error('Erro ao excluir montador:', error);
      alert('Não foi possível excluir o montador. Por favor, tente novamente.');
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (!formData.nome || !formData.cpf || !formData.empresa_montadora_id) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    if (!formData.evento_id) {
      alert('Por favor, selecione um evento para vincular este montador.');
      return;
    }

    // Validação: deve selecionar empresa montadora
    if (!empresaMontadoraSelecionada) {
      alert('Por favor, selecione uma empresa montadora para vincular este montador.');
      return;
    }
    
    // Validação do CPF
    const cpfLimpo = removeCpfMask(formData.cpf);
    if (cpfLimpo.length !== 11 || !validarCpf(cpfLimpo)) {
      setCpfValido(false);
      setCpfMensagemErro('CPF inválido. Verifique os números digitados.');
      return;
    }
    
    try {
      const montadorData = {
        nome: formData.nome,
        cpf: removeCpfMask(formData.cpf), // Remove máscara do CPF antes de salvar
        empresa_montadora_id: parseInt(formData.empresa_montadora_id),
        evento_id: parseInt(formData.evento_id),
        updated_at: new Date()
      };

      if (editingMontador) {
        const { error } = await supabase
          .from('caex_montadores')
          .update(montadorData)
          .eq('id', editingMontador.id);
        
        if (error) throw error;
        
        console.log('Montador atualizado com sucesso');
        
        // Atualizar lista local com CPF formatado
        setMontadores(montadores.map(montador => 
          montador.id === editingMontador.id ? { 
            ...montador, 
            ...montadorData,
            cpf: formatCpf(montadorData.cpf) // Aplicar máscara ao exibir
          } : montador
        ));
      } else {
        const { data, error } = await supabase
          .from('caex_montadores')
          .insert([montadorData])
          .select();
        
        if (error) throw error;
        
        console.log('Montador adicionado com sucesso:', data);
        
        // Adicionar à lista local com CPF formatado
        const newMontador = {
          ...data[0],
          cpf: formatCpf(data[0].cpf) // Aplicar máscara ao exibir
        };
        
        setMontadores([newMontador, ...montadores]);
        
        // Adicionar ao carrinho no banco de dados
        await addMontadorToCartDatabase(data[0]);
      }
      
      setShowForm(false);
      
      if (!editingMontador) {
        setEmpresaMontadoraSelecionada(null);
        setExpositorSelecionado(null);
        setFormData({
          nome: '',
          cpf: '',
          empresa_montadora_id: '',
          evento_id: ''
        });
      }
    } catch (error) {
      console.error('Erro ao salvar montador:', error);
      alert(`Não foi possível salvar o montador. Erro: ${error.message || 'Desconhecido'}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const handleEmpresaChange = (e) => {
    setFiltroEmpresa(e.target.value);
  };

  const handleTabClick = (tab) => {
    if (tab === 'acesso') {
      return;
    }
    setActiveModalTab(tab);
  };

  const navigateToCart = () => {
    navigate('/catalog/new-order');
  };

  // Renderizar notificação de carrinho
  const renderCartNotification = () => {
    if (!showCartNotification) return null;
    
    return (
      <div className="cart-notification-alert">
        <div className="alert">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <FaCheckCircle className="me-2" />
              <strong>Montador adicionado ao carrinho!</strong>
            </div>
            <Button 
              variant="outline-dark" 
              size="sm"
              onClick={() => setShowCartNotification(false)}
              className="ms-3"
            >
              <FaTimes />
            </Button>
          </div>
          
          {lastAddedItem && (
            <div className="cart-item-preview mt-2 p-2 rounded">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <FaHardHat size={24} className="text-secondary" />
                </div>
                <div>
                  <h6 className="mb-0">{lastAddedItem.name}</h6>
                  <small>{lastAddedItem.description}</small>
                </div>
              </div>
            </div>
          )}
          
          <div className="d-flex justify-content-end mt-3">
            <Button 
              variant="outline-dark" 
              size="sm" 
              className="me-2"
              onClick={() => handleAddMontador()}
            >
              <FaPlus className="me-1" /> Adicionar Outro
            </Button>
            <Button 
              variant="dark" 
              size="sm"
              onClick={navigateToCart}
            >
              Ir para o Carrinho <FaArrowRight className="ms-1" />
            </Button>
          </div>
        </div>
      </div>
    );
  };

  // Renderizar botão de carrinho
  const renderCartButton = () => {
    if (cartItemsCount === 0) return null;
    
    return (
      <Button 
        variant="outline-dark" 
        className="cart-button ms-2"
        onClick={navigateToCart}
      >
        <FaShoppingCart className="me-1" />
        Carrinho
        <span className="cart-count">{cartItemsCount}</span>
      </Button>
    );
  };

  // Funções de renderização
  const renderStatusBadge = (status) => {
    switch (status) {
      case 'ativo':
        return <Badge bg="success" className="modern-badge">Ativo</Badge>;
      case 'inativo':
        return <Badge bg="danger" className="modern-badge">Inativo</Badge>;
      case 'suspenso':
        return <Badge bg="warning" className="modern-badge">Suspenso</Badge>;
      default:
        return <Badge bg="secondary" className="modern-badge">Indefinido</Badge>;
    }
  };

  // Filtragem de montadores
  const filteredMontadores = montadores.filter(montador => {
    if (filtroEmpresa && montador.caex_empresas_montadoras?.nome !== filtroEmpresa) {
      return false;
    }
    
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      return montador.nome.toLowerCase().includes(searchTerm) || 
             montador.cpf.includes(searchTerm);
    }
    
    return true;
  });

  // Estilos para o modal flutuante (mesmo do CadastroCredenciais)
  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '1rem',
      backdropFilter: 'blur(5px)'
    },
    content: {
      position: 'relative',
      width: '100%',
      maxWidth: '650px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      overflow: 'hidden',
      animationName: 'fadeInUp',
      animationDuration: '0.4s',
      animationTimingFunction: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      animationFillMode: 'both'
    },
    header: {
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      padding: '1.5rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: 0
    },
    closeButton: {
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: 'none',
      background: 'white',
      color: '#6c757d',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#1a1a1a',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem'
    },
    tabs: {
      display: 'flex',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      backgroundColor: 'white',
      flexShrink: 0
    },
    tab: {
      padding: '1rem 1.5rem',
      fontSize: '0.95rem',
      fontWeight: '500',
      color: '#6c757d',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative'
    },
    activeTab: {
      color: '#0d6efd',
      fontWeight: '600'
    },
    disabledTab: {
      color: '#adb5bd',
      cursor: 'not-allowed',
      opacity: 0.6
    },
    activeTabIndicator: {
      position: 'absolute',
      bottom: '-1px',
      left: '0',
      right: '0',
      height: '2px',
      backgroundColor: '#0d6efd'
    },
    body: {
      padding: '2rem',
      overflowY: 'auto',
      flex: '1 1 auto'
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '1.5rem 2rem',
      borderTop: '1px solid rgba(0, 0, 0, 0.05)',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      flexShrink: 0
    },
    footerButton: {
      padding: '0.75rem 1.5rem',
      borderRadius: '50px',
      fontSize: '0.9rem',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },
    cancelButton: {
      border: '1px solid #dee2e6',
      background: 'white',
      color: '#495057',
      marginRight: '0.75rem'
    },
    submitButton: {
      border: 'none',
      background: '#212529',
      color: 'white',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
    },
    formGroup: {
      marginBottom: '1.5rem'
    },
    formLabel: {
      display: 'block',
      marginBottom: '0.5rem',
      fontSize: '0.9rem',
      fontWeight: '600',
      color: '#495057'
    },
    formInput: {
      width: '100%',
      padding: '0.75rem 1rem',
      border: '1px solid #dee2e6',
      borderRadius: '10px',
      fontSize: '0.9rem',
      color: '#495057',
      transition: 'all 0.3s ease'
    },
    requiredField: {
      color: '#dc3545',
      marginLeft: '0.25rem'
    },
    requiredNotice: {
      fontSize: '0.8rem',
      color: '#dc3545',
      marginBottom: '1rem'
    }
  };

  // Adicionar estilo de animação ao carregar o componente (mesmo do CadastroCredenciais)
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeInUp {
        from { 
          opacity: 0; 
          transform: translateY(30px);
        }
        to { 
          opacity: 1; 
          transform: translateY(0);
        }
      }
      
      .form-input {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        font-size: 0.9rem;
        color: #495057;
        transition: all 0.3s ease;
      }
      
      .form-input:focus {
        outline: none;
        border-color: #212529;
        box-shadow: 0 0 0 3px rgba(33, 37, 41, 0.1);
      }
      
      .form-input:disabled {
        background-color: #f8f9fa;
        color: #6c757d;
        cursor: not-allowed;
      }
      
      .form-input.is-invalid {
        border-color: #dc3545;
        padding-right: calc(1.5em + 0.75rem);
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
      }
      
      .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 0.8rem;
        color: #dc3545;
      }
      
      .form-label {
        display: block;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #495057;
      }
      
      .form-group {
        margin-bottom: 1.5rem;
      }
      
      .modal-close-btn:hover {
        background-color: #f8f9fa;
        color: #212529;
        transform: rotate(90deg);
      }
      
      .btn-cancel:hover {
        background-color: #f8f9fa;
      }
      
      .btn-submit:hover {
        background-color: #343a40;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
      }
      
      .modal-tab {
        position: relative;
        padding: 1rem 1.5rem;
        font-weight: 500;
        color: #6c757d;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      
      .modal-tab-active {
        color: #0d6efd;
        font-weight: 600;
      }
      
      .modal-tab-disabled {
        color: #adb5bd;
        cursor: not-allowed;
        opacity: 0.6;
      }
      
      .modal-tab-active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #0d6efd;
      }
      
      .modal-tab:hover:not(.modal-tab-active):not(.modal-tab-disabled) {
        color: #495057;
        background-color: rgba(0, 0, 0, 0.02);
      }

      .cart-notification-alert {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 1050;
        width: 350px;
        animation: slideInRight 0.3s ease-out forwards;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        overflow: hidden;
      }
      
      .cart-notification-alert .alert {
        margin-bottom: 0;
        padding: 15px 20px;
        border: none;
        border-radius: 10px;
        background: #212529;
        color: white;
      }
      
      .cart-notification-alert .btn-outline-dark {
        color: white;
        border-color: rgba(255, 255, 255, 0.5);
        transition: all 0.2s ease;
      }
      
      .cart-notification-alert .btn-outline-dark:hover {
        background-color: rgba(255, 255, 255, 0.2);
        border-color: white;
      }
      
      .cart-notification-alert .btn-dark {
        background-color: white;
        color: #212529;
        border: none;
        transition: all 0.2s ease;
      }
      
      .cart-notification-alert .btn-dark:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      }
      
      .cart-button {
        position: relative;
        transition: all 0.3s ease;
      }
      
      .cart-button:hover {
        transform: translateY(-2px);
      }
      
      .cart-button .cart-count {
        position: absolute;
        top: -8px;
        right: -8px;
        background-color: #dc3545;
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
      
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      .cart-item-added {
        animation: cartBounce 0.5s ease;
      }
      
      @keyframes cartBounce {
        0% { transform: scale(1); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
      }
      
      .cart-item-preview {
        border: 1px solid rgba(255, 255, 255, 0.3);
        background-color: #f8f9fa;
        color: #212529;
      }

      .empresa-info {
        margin-top: 0.5rem;
      }
      
      .empresa-card {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        padding: 0.75rem 1rem;
        color: '#6c757d';
        display: 'flex';
        align-items: 'center';
        gap: '0.5rem';
        font-weight: 500;
      }
      
      .empresa-card .empresa-icon {
        color: '#28a745';
      }

      .produto-card {
        display: 'flex';
        align-items: 'center';
        padding: '0.75rem';
        border: '1px solid #28a745';
        border-radius: '8px';
        margin-bottom: '0.5rem';
        background: '#f8fff9';
        cursor: 'not-allowed';
        transition: 'all 0.2s ease';
      }
      
      .produto-card.selected {
        border-color: '#28a745';
        background-color: '#f8fff9';
        box-shadow: '0 2px 8px rgba(40, 167, 69, 0.15)';
      }
      
      .produto-image {
        width: '40px';
        height: '40px';
        border-radius: '6px';
        background-color: '#f8f9fa';
        display: 'flex';
        align-items: 'center';
        justify-content: 'center';
        margin-right: '0.75rem';
        flex-shrink: 0;
      }
      
      .produto-info {
        flex: 1;
      }
      
      .produto-nome {
        font-weight: 600;
        color: '#212529';
        font-size: '0.9rem';
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Impedir o scroll quando o modal estiver aberto
  useEffect(() => {
    if (showForm || showDelete) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showForm, showDelete]);
  
  // Adicionar efeito para rolar o modal para o topo quando for aberto
  useEffect(() => {
    if (showForm) {
      setTimeout(() => {
        const modalBody = document.querySelector('.modal-scrollable-body');
        if (modalBody) {
          modalBody.scrollTop = 0;
        }
      }, 100);
    }
  }, [showForm, activeModalTab]);

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-hub">
          <div className="dashboard-header">
            <div className="dashboard-title-section">
              <h1 className="dashboard-main-title">
                <FaTools className="dashboard-title-icon" />
                Montadores
              </h1>
            </div>
          </div>
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-hub">
          <div className="dashboard-header">
            <div className="dashboard-title-section">
              <h1 className="dashboard-main-title">
                <FaTools className="dashboard-title-icon" />
                Montadores
              </h1>
            </div>
          </div>
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative my-4" role="alert">
            <strong className="font-bold">Erro: </strong>
            <span className="block sm:inline">{error}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-hub">
        <div className="dashboard-header">
          <div className="dashboard-title-section">
            <h1 className="dashboard-main-title">
              <FaTools className="dashboard-title-icon" />
              Montadores
            </h1>
            <p className="dashboard-subtitle">
              Gerenciamento de montadores e equipes de montagem
              {!isAdmin() && expositorLogado && (
                <span style={{ display: 'block', marginTop: '0.5rem', fontSize: '0.9rem', color: '#28a745' }}>
                  <FaBuilding className="me-1" />
                  {expositorLogado.nome_empresa}
                </span>
              )}
              {isAdmin() && (
                <span style={{ display: 'block', marginTop: '0.5rem', fontSize: '0.9rem', color: '#007bff' }}>
                  <FaUserTie className="me-1" />
                  Modo Administrador - Acesso Total
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-end mb-4">
          <Button 
            variant="outline-secondary" 
            className="me-2"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? <FaTimes className="me-2" /> : <FaFilter className="me-2" />}
            {showFilters ? 'Ocultar Filtros' : 'Filtros'}
          </Button>
          
          {renderCartButton()}
          
        <Button 
          variant="primary" 
          onClick={handleAddMontador}
          className="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800 transition-all flex items-center gap-2 ms-2"
          style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}
          disabled={(!isAdmin() && !expositorLogado) || (!isAdmin() && montadorasVinculadas.length === 0)}
        >
          <FaPlus className="me-2" />
          Novo Montador
        </Button>
        </div>

        {/* Área de filtros */}
        {showFilters && (
          <Card className="modern-table-card mb-4">
            <Card.Body className="modern-card-body">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Buscar por Nome ou CPF</Form.Label>
                    <div className="position-relative">
                      <Form.Control 
                        type="text" 
                        placeholder="Digite para buscar..."
                        name="search"
                        value={filters.search}
                        onChange={handleFilterChange}
                      />
                      <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>
                  </Form.Group>
                </Col>

              </Row>
            </Card.Body>
          </Card>
        )}

        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">
            <FaUsers className="dashboard-section-icon" />
            Lista de Montadores
          </h2>
          <p className="dashboard-section-subtitle">
            Visualize e gerencie os montadores cadastrados
            {!isAdmin() && expositorLogado && ` para ${expositorLogado.nome_empresa}`}
            {isAdmin() && ' - Todas as empresas'}
          </p>
        </div>

        {/* Tabela de montadores */}
        <Card className="modern-table-card">
          <Card.Body className="modern-card-body">
            <div className="modern-table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Empresa Montadora</th>
                    <th>Expositor</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMontadores.length > 0 ? (
                    filteredMontadores.map(montador => (
                      <tr key={montador.id}>
                        <td className="font-weight-bold">{montador.nome}</td>
                        <td>{montador.cpf}</td>
                        <td>{montador.caex_empresas_montadoras?.nome || 'N/A'}</td>
                        <td>
                          {montador.caex_empresas_montadoras?.caex_expositores?.nome_empresa || 'N/A'}
                        </td>
                        <td>{renderStatusBadge(montador.status)}</td>
                        <td>
                          <div className="action-buttons">
                            <Button 
                              variant="outline-primary" 
                              size="sm"
                              onClick={() => handleEditMontador(montador)}
                              className="me-1"
                              title="Editar"
                            >
                              <FaEdit />
                            </Button>
                            {/* <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleDeleteMontador(montador)}
                              title="Excluir"
                            > */}
                              {/* <FaTrash /> */}
                            {/* </Button> */}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <p className="text-muted mb-0">
                          {!isAdmin() && expositorLogado 
                            ? 'Nenhum montador encontrado para esta empresa' 
                            : isAdmin()
                            ? 'Nenhum montador encontrado no sistema'
                            : 'Nenhum montador encontrado'
                          }
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>

        {/* Modal de formulário */}
        {showForm && (
          <div style={modalStyles.overlay}>
            <div style={modalStyles.content}>
              <div style={modalStyles.header}>
                <h2 style={modalStyles.title}>
                  {editingMontador 
                    ? <FaEdit style={{color: '#6c757d'}} /> 
                    : <FaPlus style={{color: '#6c757d'}} />
                  }
                  {editingMontador ? 'Editar Montador' : 'Novo Montador'}
                </h2>
                <button 
                  onClick={() => setShowForm(false)}
                  style={modalStyles.closeButton}
                  className="modal-close-btn"
                  aria-label="Fechar"
                >
                  ✕
                </button>
              </div>

              <div style={modalStyles.tabs}>
                <div 
                  className={`modal-tab ${activeModalTab === 'dados' ? 'modal-tab-active' : ''}`}
                  onClick={() => handleTabClick('dados')}
                >
                  Dados Pessoais
                </div>
                <div 
                  className={`modal-tab ${activeModalTab === 'montador' ? 'modal-tab-active' : ''}`}
                  onClick={() => handleTabClick('montador')}
                >
                  Montador & Evento
                </div>
              </div>
              
              <div style={modalStyles.body} className="modal-scrollable-body">
                {activeModalTab === 'dados' && (
                  <>
                    <div className="form-group">
                      <label className="form-label" htmlFor="empresa_montadora_id">
                        Empresa Montadora <span style={modalStyles.requiredField}>*</span>
                      </label>
                      {renderEmpresaMontadoraField()}
                      <small style={{ color: '#6c757d', fontSize: '0.8rem', marginTop: '0.25rem', display: 'block' }}>
                        Selecione a empresa montadora responsável por este montador
                      </small>
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="evento_id">
                        Evento <span style={modalStyles.requiredField}>*</span>
                      </label>
                      {renderEventosDropdown()}
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label" htmlFor="nome">
                        Nome Completo <span style={modalStyles.requiredField}>*</span>
                      </label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Digite o nome completo"
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label" htmlFor="cpf">
                        CPF <span style={modalStyles.requiredField}>*</span>
                      </label>
                      <input
                        type="text"
                        id="cpf"
                        name="cpf"
                        value={formData.cpf}
                        onChange={handleCpfChange}
                        className={`form-input ${!cpfValido ? 'is-invalid' : ''}`}
                        placeholder="000.000.000-00"
                        maxLength="14"
                        required
                      />
                      {!cpfValido && (
                        <div className="invalid-feedback">
                          {cpfMensagemErro}
                        </div>
                      )}
                    </div>
                    
                    <div style={modalStyles.requiredNotice}>
                      * Campos obrigatórios
                    </div>
                  </>
                )}
                
                {activeModalTab === 'montador' && (
                  <>
                    <div className="form-group">
                      <label className="form-label" htmlFor="produto">
                        <FaBox className="me-2" />
                        Produtos Vinculados ao Montador
                      </label>
                      {renderProdutosDropdown()}
                      <small style={{ color: '#6c757d', fontSize: '0.8rem', marginTop: '0.25rem', display: 'block' }}>
                        Produtos automaticamente vinculados a montadores (apenas para visualização)
                      </small>
                    </div>
                    
                    
                    <div style={modalStyles.requiredNotice}>
                      * Campos obrigatórios
                    </div>
                  </>
                )}
              </div>
              
              <div style={modalStyles.footer}>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  style={{...modalStyles.footerButton, ...modalStyles.cancelButton}}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{...modalStyles.footerButton, ...modalStyles.submitButton}}
                  className="btn-submit"
                >
                  {editingMontador ? 'Atualizar' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de confirmação de exclusão */}
        {showDelete && (
          <div style={modalStyles.overlay}>
            <div style={{...modalStyles.content, maxWidth: '500px'}}>
              <div style={modalStyles.header}>
                <h2 style={modalStyles.title}>
                  <FaTrash style={{color: '#dc3545'}} />
                  Confirmar Exclusão
                </h2>
                <button 
                  onClick={() => setShowDelete(false)}
                  style={modalStyles.closeButton}
                  className="modal-close-btn"
                  aria-label="Fechar"
                >
                  ✕
                </button>
              </div>
              
              <div style={modalStyles.body} className="modal-scrollable-body">
                {editingMontador && (
                  <p style={{fontSize: '1rem', marginBottom: '1.5rem'}}>
                    Tem certeza que deseja excluir o montador <strong>{editingMontador.nome}</strong>?
                  </p>
                )}
                
                <div style={{
                  backgroundColor: '#fff3cd',
                  color: '#856404',
                  padding: '1rem',
                  borderRadius: '10px',
                  border: '1px solid #ffeeba',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '0.5rem'
                }}>
                  <FaExclamationTriangle style={{marginTop: '0.2rem'}} />
                  <div>
                    Esta ação não pode ser desfeita e o montador será removido permanentemente do sistema.
                  </div>
                </div>
              </div>
              
              <div style={modalStyles.footer}>
                <button
                  type="button"
                  onClick={() => setShowDelete(false)}
                  style={{...modalStyles.footerButton, ...modalStyles.cancelButton}}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={() => deleteMontador(editingMontador.id)}
                  style={{
                    ...modalStyles.footerButton,
                    ...modalStyles.submitButton,
                    background: '#dc3545'
                  }}
                  className="btn-submit"
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Notificação de adição ao carrinho */}
        {renderCartNotification()}
      </div>
    </div>
  );
};

export default Montadores;